import { render, staticRenderFns } from "./Insurances.vue?vue&type=template&id=3a1c4cbe&scoped=true&"
import script from "./Insurances.vue?vue&type=script&lang=ts&"
export * from "./Insurances.vue?vue&type=script&lang=ts&"
import style0 from "./Insurances.vue?vue&type=style&index=0&id=3a1c4cbe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1c4cbe",
  null
  
)

export default component.exports